module.exports = __webpack_public_path__ + "static/media/Trazado 9147@2x.fdf4797c.png";